import SplitEDDItemsList from 'components/SharedComponents/SplitEDD/SplitEDDItemsList/SplitEDDItemsList';
import { withSplitEDDShippingMethodProps } from 'viewModel/sharedComponents/splitEDD/splitEDDItemsList/withSplitEDDItemsListProps';

export default withSplitEDDShippingMethodProps(SplitEDDItemsList);
